import React from "react";
import { CiWarning } from "react-icons/ci";
import { useStores } from "../../store";
import { useNavigate } from "react-router-dom";
import { logout } from "../../api/api_methods";
function AccountVerification() {
  const { UserStore } = useStores();
  const navigate = useNavigate();
  return (
    <>
      <div className="h-[90vh] w-screen flex items-center justify-center flex-col     ">
        <div className=" bg-white h-fit max-sm:px-4 flex flex-row justify-around items-center align-middle max-sm:mx-0 mx-auto mg-agent-shadow w-fit rounded-xl">
          {/* <img src={verify} className="w-[500px] object-cover "></img> */}
          <div className="verification-icon max-sm:px-0 md:flex lg:flex hidden items-center text-[#FFBF00]  md:text-7xl px-3 md:w-[8%] ">
            <CiWarning className="text-[5em]" />
          </div>
          <div className="flex flex-col items-center gap-10 md:text-xl lg:text-2xl text-lg w-[80%] py-4">
            <p className=" w-full text-primary text-3xl md:text-5xl font-extrabold ">
              Account Verification in Progress
            </p>
            <p className=" text-xl md:text-xl text-gray-400 whitespace-pre-line">
              Your account is currently under verification. We appreciate your
              patience as we ensure the security and accuracy of your
              information. The verification process will be completed within 12
              hours. Once verified, you'll have full access to our platform's
              features.
              <br /> In the meantime, feel free to{" "}
              <a
                target="_blank"
                href="https://calendly.com/satish-spotmies/30min"
                className="hover:underline  cursor-pointer  text-black"
              >
                Schedule a demo
              </a>{" "}
              meeting to explore Reaidy.io and learn how it can streamline your
              hiring process.
            </p>
            {/* <p>{UserStore?.userDetails?.isAccountVerified}</p> */}
          </div>
        </div>
        <div className="flex items-center gap-3 mt-5">
          <button
            className="bg-primary text-white px-4 py-2 rounded-lg shadow-md hover:shadow-lg focus:outline-none w-40 transition-all duration-200"
            onClick={async () => {
              await UserStore.getUserDetails(true);
              navigate("/");
            }}
          >
            Refresh
          </button>
          <button
            className="bg-white text-primary px-4 py-2 rounded-lg shadow-md hover:shadow-lg focus:outline-none w-40 border-2 border-primary hover:bg-primary/5 transition-all duration-200"
            onClick={async () => {
              await logout();
              try {
                await logout();
                localStorage.removeItem("user");
                localStorage.removeItem("user_google");
                sessionStorage.clear();
                navigate("/");
              } catch (error) {
                console.log(error);
                navigate("/");
              }
            }}
          >
            Logout
          </button>
        </div>
      </div>

      <div className="mx-auto w-fit flex justify-between gap-3 px-5 md:text-lg lg:text-lg text-[10px] ">
        <a
          target="_blank"
          href="https://calendly.com/satish-spotmies/30min"
          className="hover:underline cursor-pointer text-black px-3 whitespace-nowrap border-r  border-primary "
        >
          Schedule a Meeting
        </a>
        <a
          target="_blank"
          href="mailto:connect@reaidy.io"
          className="hover:underline cursor-pointer text-black px-3 whitespace-nowrap border-r  border-primary "
        >
          connect@reaidy.io
        </a>
        <a
          target="_blank"
          href="tel:8019933883"
          className="hover:underline cursor-pointer text-black px-3 whitespace-nowrap   "
        >
          +91 8019933883
        </a>
      </div>
    </>
  );
}

export default AccountVerification;
